<template>
  <div class="v-popover" :class="cssClass">
    <!--
      style="display: inline-block;" を除去
      https://github.com/Akryum/v-tooltip/blob/v2.0.0-rc.31/src/components/Popover.vue#L6
    -->
    <span
      ref="trigger"
      class="trigger"
      :aria-describedby="popoverId"
      :tabindex="trigger.indexOf('focus') !== -1 ? 0 : -1"
    >
      <slot />
    </span>

    <div
      ref="popover"
      :id="popoverId"
      :class="[popoverBaseClass, popoverClass, cssClass]"
      :style="{
        visibility: isOpen ? 'visible' : 'hidden',
      }"
      :aria-hidden="isOpen ? 'false' : 'true'"
    >
      <div :class="popoverWrapperClass">
        <div ref="inner" :class="popoverInnerClass" style="position: relative;">
          <div>
            <slot name="popover" />
          </div>

          <ResizeObserver v-if="handleResize" @notify="$_handleResize" />
        </div>
        <div ref="arrow" :class="popoverArrowClass"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Popover from './Popover'

export { default as ClosePopover } from './ClosePopover'

/**
 * バルーンの表示を管理するコンポーネント
 *
 * [v-tooltip](https://github.com/Akryum/v-tooltip) を使用しています。
 */
export default {
  name: 'Popover',
  extends: Popover,
}
</script>

<style lang="postcss" scoped>
.v-popover {
  display: flex;
  height: fit-content;
  width: fit-content;

  &.full {
    width: 100%;
  }

  .responsive & {
    height: auto;
    width: auto;
  }
}

.trigger {
  display: inline-flex;
  outline: none;
  width: 100%;
}

.popover {
  display: block !important;
  z-index: 10000;

  $color: #f9f9f9;

  .popover-inner {
    background: var(--white);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
    overflow: hidden;
  }

  .popover-arrow {
    border-style: solid;
    height: 0;
    margin: 5px;
    position: absolute;
    width: 0;
    z-index: 1;

    &::after {
      border-style: solid;
      content: '';
      height: 0;
      position: absolute;
      width: 0;
    }
  }

  &[x-placement^='top'] {
    margin-bottom: 8px;

    .tooltip-arrow {
      border-color: var(--border-color) transparent transparent;
      border-width: 16px 16px 0;
      bottom: -16px;
      left: calc(50% - 16px);
      margin-bottom: 0;
      margin-top: 0;

      &::after {
        border-color: var(--white) transparent transparent;
        border-width: 16px 16px 0;
        bottom: 1px;
        left: -16px;
        margin-bottom: 0;
        margin-top: 0;
      }
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 8px;

    .tooltip-arrow {
      border-color: transparent transparent var(--border-color);
      border-width: 0 16px 16px;
      left: calc(50% - 16px);
      margin-bottom: 0;
      margin-top: 0;
      top: -16px;

      &::after {
        border-color: transparent transparent var(--white);
        border-width: 0 16px 16px;
        left: -16px;
        margin-bottom: 0;
        margin-top: 0;
        top: 1px;
      }
    }
  }

  &[x-placement^='right'] {
    margin-left: 8px;

    .tooltip-arrow {
      border-color: transparent var(--border-color) transparent transparent;
      border-width: 16px 16px 16px 0;
      left: -16px;
      margin-left: 0;
      margin-right: 0;
      top: calc(50% - 16px);

      &::after {
        border-color: transparent var(--white) transparent transparent;
        border-width: 16px 16px 16px 0;
        left: 1px;
        margin-left: 0;
        margin-right: 0;
        top: -16px;
      }
    }
  }

  &[x-placement^='left'] {
    margin-right: 8px;

    .tooltip-arrow {
      border-color: transparent transparent transparent var(--border-color);
      border-width: 16px 0 16px 16px;
      margin-left: 0;
      margin-right: 0;
      right: -16px;
      top: calc(50% - 16px);

      &::after {
        border-color: transparent transparent transparent var(--white);
        border-width: 16px 0 16px 16px;
        margin-left: 0;
        margin-right: 0;
        right: 1px;
        top: -16px;
      }
    }
  }

  &[aria-hidden='true'] {
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
    visibility: hidden;
  }

  &[aria-hidden='false'] {
    opacity: 1;
    transition: opacity 0.15s;
    visibility: visible;
  }
}

.behind-popover {
  z-index: 100;
}
</style>
